module.exports = {
  title: 'How Does the Office Space Calculator Work?',
  callToActionTitle: `Ready to find out how much space you need?`,
  pageTitle: 'How Does the Office Space Calculator Work? — Spacer by CBRE',
  metaTagText: 'Use this free tool to generate custom recommendations and start planning your new office space. Learn more here.',
  preview: `
    The workplace is the home of your organization. People meet, focus, socialize,
    strategize, sell, think, make, and do at the office. It is where your
    organization happens. It should accommodate you as you grow and as your work
    changes. It should be convenient. It should reflect your brand and the values
    that make your organization special.
  `,
  content: `
    <p>
    The right office doesn’t happen by accident. It’s the result of knowing what your
    team needs — and building a space that supports it.
    </p>
    <p>
    That’s the problem CBRE’s office space calculator is designed to solve. It gives
    you a concrete, data-backed recommendation for how much space you need and
    how that space should be broken down — before you start your property search.
    </p>
    <h2>What the calculator does</h2>
    <p>
    The calculator starts with a short profiling quiz. You answer a few questions
    about your organization — your team size, how people work, what matters most
    to your culture and the kind of office environment you want to create.
    </p>
    <p>
    The tool doesn’t apply a one-size-fits-all formula. There’s no single ‘tech’ profile
    or ‘finance’ profile. Your answers define a profile specific to your organization —
    because companies that look similar on paper often work in very different ways.
    </p>
    <h2>What you get</h2>

    <p>
    Based on your answers, the calculator produces:
    <ul class="has-margin-left-6 has-margin-bottom-5" style="list-style: disc">
      <li class="has-margin-left-6">  A recommended office size in rentable or usable square feet (your choice)</li>
      <li class="has-margin-left-6">  A breakdown of the space types you need — individual workstations, private
      offices, enclosed meeting rooms, collaboration areas, phone rooms and more</li>
      <li class="has-margin-left-6">  Quantities and sizing for each space type</li>
      <li class="has-margin-left-6">  The seat ratios and density figures behind the recommendation</li>
    </ul>
    </p>
    <p>
    All figures are based on CBRE’s workplace benchmarks, drawn from years of
    space planning work across real organizations globally. The recommendations are
    a starting point, not a fixed blueprint — you can adjust figures to reflect your
    specific situation.
    </p>

    <h2>What to do with your results</h2>

    <p>
    Your results give you a space program — a document that defines what your
    office needs to contain and how big it should be. This is exactly what a broker
    needs to shortlist properties that fit your requirements and what an architect or
    fit-out team needs to start planning your layout.
    </p>
    <p>
    Save your results to refer to during your search. Or connect with a CBRE broker
    directly — they can use your program to find spaces that match, at no cost to
    you.
    </p>
    <h2>How long does it take?</h2>
    <p>
    The quiz takes around 15 minutes to complete. There’s no sign-up required to
    see your results.
    </p>
    <p>
    If you have questions or want to go further, contact us at
    <a href="mailto:spacersupport@cbre.com">spacersupport@cbre.com</a>.
    </p>
  `
};
